import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledPopularCategories = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.white};
  padding-top: 60px;

  .title {
    text-align: left;
    padding-bottom: 15px;
    font-weight: 300;

    h1 {
      font-size: 42px;
      font-weight: 500;
      line-height: 38px;
      margin: 0 0 54px;
    }
  }

  .container-category {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;

    .ant-card {
      max-width: none;
      width: 100%;
    }

    .ant-card-cover img {
      width: 100%;
      height: 194px;
      object-fit: cover;
    }
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    .container-category {
      grid-template-columns: repeat(2, 1fr);
    }

    .title {
      text-align: left;
      padding: 1em 0 0 1em;

      h1 {
        font-size: 24px;
      }
    }
  }

  /* hidden on phones; MobileProductCategoriesCarousel takes over */
  @media only screen and (max-width: ${breakpoints.xs}px) {
    display: none;
  }
`;
